

export const API_URL = `${process.env.REACT_APP_API_DOMAIN}${process.env.REACT_APP_API_PATH}` 